<div class="fpui-step" v-if="isActive"><slot></slot></div>